import React, { createContext, FC, useState } from 'react';
import { MatchDetailsTabs } from '../components/TournamentMatchDetailsModal';

interface ActiveMatchProviderProps {
  activeMatchId: null | number;
  setActiveMatchId: (matchId: number | null) => void;
  activeTab: null | MatchDetailsTabs;
  setActiveTab: (tab: MatchDetailsTabs | null) => void;
}

export const ActiveMatchContext = createContext<ActiveMatchProviderProps>({
  activeMatchId: null,
  setActiveMatchId: () => {},
  activeTab: null,
  setActiveTab: () => {},
});

export const ActiveMatchProvider: FC<ActiveMatchProviderProps> = ({ children }) => {
  const [activeMatchId, setActiveMatchId] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState<MatchDetailsTabs | null>(MatchDetailsTabs.Games);

  return (
    <ActiveMatchContext.Provider
      value={{
        activeMatchId,
        setActiveMatchId: (matchId) => setActiveMatchId(matchId),
        activeTab,
        setActiveTab: (tab) => setActiveTab(tab),
      }}
    >
      {children}
    </ActiveMatchContext.Provider>
  );
};
